"use client";

import React, { createContext, useContext, useState } from "react";

interface ListingEditorVisibilityContextType {
  isListingEditorVisible: boolean;
  setListingEditorVisible: (visible: boolean) => void;
}

const ListingEditorVisibilityContext = createContext<
  ListingEditorVisibilityContextType | undefined
>(undefined);

export function ListingEditorVisibilityProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isListingEditorVisible, setListingEditorVisible] = useState(false);

  return (
    <ListingEditorVisibilityContext.Provider
      value={{ isListingEditorVisible, setListingEditorVisible }}
    >
      {children}
    </ListingEditorVisibilityContext.Provider>
  );
}

export function useListingEditorVisibility() {
  const context = useContext(ListingEditorVisibilityContext);
  if (context === undefined) {
    throw new Error(
      "useListingEditorVisibility must be used within a ListingEditorVisibilityProvider",
    );
  }
  return context;
}
